import { render } from "./Notes10.vue?vue&type=template&id=61694704&scoped=true"
import script from "./Notes10.vue?vue&type=script&lang=js"
export * from "./Notes10.vue?vue&type=script&lang=js"

import "./Notes10.vue?vue&type=style&index=0&id=61694704&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61694704"]])

export default __exports__